
import {
  conversational_ai,tutorials,
  clg3,clg4,clg5,clg6,site_integrity_report,
  multi_channel,continuous_engage,live_agent,chat,ai_smart_fill
} from "../../assets/images";



export const collegeCardsData = [
  {
    image: conversational_ai,
    title: "Unified Admin Dashboard",
    description:
      "Monitor interactions, track performance, and access reports from one place.",
  },
  {
    image: tutorials,
    title: "Workflow & Task Management",
    description:
      "Organize, prioritize, and automate campus workflows effortlessly.",
  },
  {
    image: clg3,
    title: "AI-Powered Campus Solutions",
    description:
      "Simplify operations with smart tools for form automation, transcript evaluation, and content generation.",
  },
  {
    image: site_integrity_report,
    title: "Site Integrity Report",
    description:
      "Flags outdated or inaccurate content to keep your site fresh and reliable.",
  },
  {
    image: clg4,
    title: "Seamless Integrations",
    description:
      "Connect CRM, SIS, and LMS systems for a unified experience",
  },
  {
    image: clg5,
    title: "Security & Compliance",
    description:
      "FERPA-compliant hosting with enterprise-level security and cloud scalability.",
  },
  {
    image: clg6,
    title: "Custom Forms & Knowledge Management",
    description:
      "Build dynamic forms and manage institutional knowledge with ease.",
  },
];


export const studentCardsData = [
  {
    image: conversational_ai,
    title: "Conversational AI",
    description:
      "Engage with an AI-powered, multilingual assistant that supports smart follow-ups and multi-turn conversations.",
    altText: "Futuristic AI technology illustration with glowing blue holographic letters spelling AI on a digital circuit board background"
  },
  {
    image: tutorials,
    title: "Tutorials for Students",
    description:
      "Access a rich library of videos and documentation to guide you through every step.",
    altText: "Student working on laptop with notebooks and study materials on desk, overhead view of learning environment"
  },
  {
    image: multi_channel,
    title: "Multi-Channel & Language Support",
    description:
      "Connect seamlessly across multiple platforms in your preferred language.",
    altText: "Colorful abstract symbols and letters representing multiple languages and communication channels"
  },
  {
    image: ai_smart_fill,
    title: "Smart Forms",
    description:
      "AI guided form fills with precision and accuracy - no clicks wasted!.",
    altText: "Digital interface showing AI-powered form automation with holographic elements and smart data processing"
  },
  {
    image: live_agent,
    title: "Live Agent Handoff",
    description:
      "Get timely human support whenever you need it.",
    altText: "Professional using tablet device showing customer service and human support interface"
  },
  {
    image: chat,
    title: "Secure Chat History",
    description:
      "Enjoy private, authorized access to all your past conversations.",
    altText: "Secure digital communication interface with encryption symbols and protected chat history display"
  },
  {
    image: continuous_engage,
    title: "Continuous Engagement",
    description:
      "Stay connected with proactive updates and personalized interactions.",
    altText: "Team collaboration scene with diverse group of people working together on laptop showing engagement tools"
  },
];